<template>
  <div>
    <v-tabs height="60px" show-arrows v-model="currentTab" background-color="#434343" color="#d59e1d">
      <v-tab href="#tab-ongoing-trips">Ongoing Trips</v-tab>
      <v-tab href="#tab-ended-trips">Completed Trips</v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentTab">
      <v-tab-item id="tab-ongoing-trips" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition">
        <TripHistory tripStatus="ongoing"></TripHistory>
      </v-tab-item>
      <v-tab-item id="tab-ended-trips" class="tab-outer" transition="fade-transition" reverse-transition="fade-transition">
        <TripHistory tripStatus="ended"></TripHistory>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import TripHistory from "./TripHistory.vue";

export default {
  name: "IndigoTrips",
  components: { TripHistory },
  data() {
    return {
      currentTab: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.trip-filter-blk {
  padding: 20px;
  background-color: white;
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
}
</style>
